import { render, staticRenderFns } from "./ProjectsItemTabelle.vue?vue&type=template&id=b1deb2a4&scoped=true&"
import script from "./ProjectsItemTabelle.vue?vue&type=script&lang=js&"
export * from "./ProjectsItemTabelle.vue?vue&type=script&lang=js&"
import style1 from "./ProjectsItemTabelle.vue?vue&type=style&index=1&id=b1deb2a4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1deb2a4",
  null
  
)

export default component.exports